<template>
    <div class="address-list">
        <template v-for="item in blok.Addresses" :key="item._uid">
            <div v-if="item?.component === 'Address'" class="address-list-item">
                <NuxtImg :src="item.Icon.filename" :title="item.Icon.title" :alt="item.Icon.alt" class="icon" />
                <div class="content">
                    <div class="title">{{ item.Title }}</div>
                    <div class="address">{{ item.Address }}</div>
                </div>
            </div>
            <div
                v-if="item?.component === 'AddressEntity' && item.Entity?.content?.address?.[0]"
                class="address-list-item"
            >
                <NuxtImg :src="item.Icon.filename" :title="item.Icon.title" :alt="item.Icon.alt" class="icon" />
                <div class="content">
                    <div class="title">{{ item.Entity.name }}</div>
                    <div class="address">
                        {{ item.Entity.content.address[0].name }}, {{ item.Entity.name }},
                        {{ item.Entity.content.address[0].postal_code }}
                    </div>
                </div>
            </div>
        </template>
        <div v-if="blok.GoogleMaps && blok.GoogleMapsButton" class="google-map">
            <a :href="blok.GoogleMaps" target="_blank" rel="noopener"> From my location </a>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{ blok: any }>();
</script>

<style lang="postcss" scoped>
.address-list {
    @apply flex flex-col gap-4 h-full;
}
.address-list-item {
    @apply flex items-start order-1;

    .icon {
        @apply min-h-[53px] min-w-[38px] mx-4;
    }

    .content {
        .title {
            @apply text-primary font-semibold text-xl;
        }
        .address {
            @apply py-4 text-gray-600 text-base whitespace-pre-wrap;
        }
    }
}

.google-map {
    @apply flex flex-col justify-end flex-1 order-2;

    a {
        @apply w-full bg-primary rounded-md text-white font-semibold text-2xl text-center py-3;
    }
}
</style>
